/* eslint-disable no-nested-ternary,no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Route, Switch, withRouter} from 'react-router-dom';
import {withCookies, Cookies} from 'react-cookie';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import request from 'superagent';
import postscribe from "postscribe";
import Header from "./components/Header/Header";
import PulsatingLogo from "./components/PulsatingLogo/PulsatingLogo";
import LiquidityEdgeHeader from './components/Header/LiquidityEdgeHeader';
import Footer from "./components/Footer/Footer";
import LiquidityEdgeFooter from "./components/Footer/LiquidityEdgeFooter";
import CareersFooter from "./components/Footer/CareersFooter";
import Media from "./components/Media";
import {isLandingPage, slugifyUrl, stripTrailingSlash} from "./helpers/filters";
import API, {twillBase} from "./config/API";
import {analyticsListeners, trackPage} from "./helpers/listeners/analytics";
import KnowledgeCenterQuery from "./components/KnowledgeCenter/KnowledgeCenterQuery";
import TimelineMilestoneQuery from "./components/TimelineMilestone/TimelineMilestoneQuery";
import {getParameterByName} from "./helpers/url";
import linkVideoModules from "./helpers/videoModuleLinking";
import CareersQuery from "./components/Careers/CareersQuery";
import AuthPage from './pages/AuthPage';
import PageNotFound from './pages/404/404';
import ComponentPage from "./pages/ComponentPage";
import WhatsNew from './pages/WhatsNew/WhatsNew';
// import OpenTradingInteractive from './pages/Interactive/OpenTradingInteractive';
import SiteIntroPage from "./pages/SiteIntro/SiteIntroPage";
import DealerRankings from "./pages/DealerRankings/DealerRankings";
import Charts from "./pages/Charts/Charts";
import IndexCharts from "./pages/IndexCharts/IndexCharts";
import InfographicLanding from "./pages/InfographicLanding/InfographicLanding";
import JobSingle from "./components/JobSingle/JobSingle";
import LiveMarkets from './pages/LiveMarkets/LiveMarketsPage';
import Revision from "./pages/Revision/Revision";
import './App.scss';
import TwillContent from "./components/TwillContent/TwillContent";

interface Data {
    landingPagesGraphqlMixed: Array<{
        results: Array<{
            entityLabel: string;
            entityUrl: Array<{
                path: string
            }>;
            entityId: string;
            entityBundle: string;
            fieldContainerOptions: Array<{}>;
            fieldPageProtectionByRole: Array<{
                targetId: string;
            }>
        }>;
    }>;
    siteIntroGraphql: Array<{
        results: Array<{
            entityId: string;
            entityLabel: string;
            entityBundle: string;
            entityUrl: Array<{
                path: string
            }>;
            body: Array<{
                processed: string;
            }>;
            entityMetatags: Array<{
                key: string;
                value: string;
            }>;
            fieldBackgroundImageMedia: Array<{
                entity: Array<{
                    fieldMediaImage: Array<{
                        url: string;
                    }>;
                }>;
            }>;
        }>;
    }>;
    articlesGraphql: Array<{
        results: Array<{
            title: string;
        }>;
    }>;
    sftrInfographicLandingGraphql: Array<{
        results: Array<{
            entityLabel: string;
            entityBundle: string;
            entityId: string;
            entityUrl: Array<{
                path: string
            }>;
        }>;
    }>;
    mobileOptimizedPageGraphqlView: Array<{
        results: Array<{
            entityLabel: string;
            entityBundle: string;
            entityId: string;
            entityUrl: Array<{
                path: string
            }>;
        }>;
    }>;
    mainMenu: Array<{
        links: Array<{}>;
    }>;
    liquidityEdgeMenu: Array<{
        links: Array<{}>;
    }>;
    footerMenu: Array<{
        links: Array<{}>;
    }>;
    footerCareersMenu: Array<{
        links: Array<{}>;
    }>;
    footerLegalMenu: Array<{
        links: Array<{}>;
    }>;
    usDealers: Array<{
        links: Array<{}>;
    }>;
    ukDealers: Array<{
        links: Array<{}>;
    }>;
}

class PagesQuery extends Query<Data, {id: string}> {}

const GET_PAGES = gql`
query siteStructureQuery {
  landingPagesGraphqlMixed: nodeQuery(limit: 10000,
      filter: {conditions: [{operator: EQUAL, field: "type", value: ["landing_page"]}, {operator: EQUAL, field: "type", value: ["post_trade_page"]}, {operator: EQUAL, field: "type", value: ["legal_page"]}], conjunction: OR}
  ) {

      results: entities {
        ... on NodeLandingPage {
          overridePrimaryNavigationMenu {
              entity {
                  entityId
            }
          }
          fieldOverrideFooter {
              entity {
                  entityId
              }
          }
          fieldSubNavigationMenu {
              entity {
                  entityId
                }
            }
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
          entityPublished
          fieldContainerOptions
          fieldPageProtectionByRole {
            targetId
		  }
        }
        ... on NodeLegalPage {
          fieldSecondaryNavigationMenu {
              entity {
                  entityId
              }
          }
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
          entityPublished
          fieldContainerOptions
          fieldPageProtectionByRole {
            targetId
          }
        }
        ... on NodeDealerRankingsPage {
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
          entityPublished
          fieldContainerOptions
          fieldPageProtectionByRole {
            targetId
          }
        }
        ... on NodePostTradePage {
          fieldSubNavigationMenu {
              entity {
                  entityId
              }
          }
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
          entityPublished
          fieldContainerOptions
          fieldPageProtectionByRole {
            targetId
          }
        }
      }
  }
  sftrInfographicLandingGraphql: nodeQuery(limit: 10000, filter: {conditions: [{operator: EQUAL, field: "type", value: ["sftr_infographic_landing"]}]}) {
      results: entities {
        ... on NodeSftrInfographicLanding {
          entityPublished
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
        }
      }
    }
    articlesGraphql: nodeQuery(limit: 10000, filter: {conditions: [{operator: EQUAL, field: "type", value: ["article"]}]}) {
        results: entities {
        ... on NodeArticle {
          entityUrl {
            path
            routed
          }
          entityMetatags {
            key
            value
          }
          fontOverride: fieldFontOverride
          entityBundle
          id: entityId
          cssId: fieldCssId
          title: entityLabel
          content: body {
              processed
              summaryProcessed
          }
          category: fieldCategory
          hideImageFromArticle: fieldHideImageFromArticle
          articleViewTitle: fieldArticleViewTitle
          keyword: fieldKeyword
          linkDisplay: fieldKcArLinkDisplayType
          authors: fieldAuthors
          supportingImage: fieldSupportingImageMedia {
              entity {
                  ... on MediaImage {
                      fieldMediaImage {
                          url
                          alt
                      }
                  }
              }
          }
          date: fieldItemDate {
              value
          }
          link: fieldItemLink {
              title
              uri
          }
          ctas: fieldArticleCtas {
              targetRevisionId
          }
          type: fieldArticleType
          entityPublished
          fieldArticleComponents {
            targetRevisionId
          }
          fieldSubtitle
        }
      }
    }
  siteIntroGraphql: nodeQuery(limit: 10000, filter: {conditions: [{operator: EQUAL, field: "type", value: ["site_intro_page"]}]}) {
      results: entities {
          ... on NodeSiteIntroPage {
              entityPublished
              entityId
              entityLabel
              entityBundle
              entityUrl {
                  path
              }
              body {
                  processed
              }
              entityMetatags {
                  key
                  value
              }
              fieldBackgroundImageMedia {
                  entity {
                      ... on MediaImage {
                          fieldMediaImage {
                              url
                          }
                      }
                  }
              }
          }
      }
    }
  mobileOptimizedPageGraphqlView: nodeQuery(limit: 10000, filter: {conditions: [{operator: EQUAL, field: "type", value: ["mobile_optimized_page"]}]}) {
        results: entities {
        ... on NodeMobileOptimizedPage {
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
          entityPublished
        }
      }
    }
  mainMenu: menuByName(name: "mainmega") {
    name
      links {
          label
          url {
            routed
            path
          }
          links {
              label
              url {
                routed
                path
              }
              links {
                  label
                  url {
                    routed
                    path
                  }
                }
              }
            }
  }
  liquidityEdgeMenu: menuByName(name: "liquidity-edge-navigation") {
    name
      links {
          label
          url {
            routed
            path
          }
          links {
              label
              url {
                routed
                path
              }
              links {
                  label
                  url {
                    routed
                    path
                  }
                }
              }
            }
          }
  footerMenu: menuByName(name: "footer") {
      links {
          label
          url {
            routed
            path
          }
        }
  }
  footerCareersMenu: menuByName(name: "footer-careers") {
      links {
          label
          url {
            routed
            path
          }
    }
  }
  footerLegalMenu: menuByName(name: "footerlegal") {
      links {
          label
          url {
            routed
            path
          }
        }
  }
  usDealers: menuByName(name: "menu-us-dealers") {
      links {
          label
          links {
              label
              url {
                routed
                path
                  ... on EntityCanonicalUrl {
                    internalPath: pathInternal
                  }
              }
            }
          }
        }
  ukDealers: menuByName(name: "uk-dealers") {
      links {
          label
          links {
              label
              url {
                routed
                path
                  ... on EntityCanonicalUrl {
                    internalPath: pathInternal
                }
              }
            }
          }
    }
}
`;

const GET_TRANSLATE_PATH_QUERY = gql`
query translatePathQuery($id: String!) {
  nodeById(id: $id) {
    ... on Node {
      ... on NodeLandingPage {
        overridePrimaryNavigationMenu {
            entity {
                entityId
          }
        }
        fieldOverrideFooter {
            entity {
                entityId
          }
        }
        fieldSubNavigationMenu {
            entity {
                entityId
          }
        }
        entityLabel
        entityUrl {
          path
        }
        entityId
        entityBundle
        fieldContainerOptions
        fieldPageProtectionByRole {
          targetId
        }
      }
      ... on NodeMobileOptimizedPage {
        entityLabel
        entityUrl {
          path
        }
        entityId
        entityBundle
      }
      ... on NodeLegalPage {
        entityLabel
        entityUrl {
          path
        }
        entityId
        entityBundle
        fieldContainerOptions
        fieldPageProtectionByRole {
          targetId
        }
      }
      ... on NodePostTradePage {
        fieldSubNavigationMenu {
            entity {
                entityId
          }
        }
        entityLabel
        entityUrl {
          path
        }
        entityId
        entityBundle
        fieldContainerOptions
        fieldPageProtectionByRole {
          targetId
        }
      }
      ... on NodeDealerRankingsPage {
        entityLabel
        entityUrl {
          path
        }
        entityId
        entityBundle
        fieldContainerOptions
        fieldPageProtectionByRole {
          targetId
        }
      }
      ... on NodeSftrInfographicLanding {
          entityLabel
          entityUrl {
            path
          }
          entityId
          entityBundle
        }
      ... on NodeSiteIntroPage {
          entityId
          entityLabel
          entityBundle
          entityUrl {
            path
          }
          body {
            processed
          }
          entityMetatags {
            key
            value
          }
          fieldBackgroundImageMedia {
              entity {
                  ... on MediaImage {
                      fieldMediaImage {
                          url
                      }
                  }
              }
          }
        }
    }
  }
}
`;

const checkAuthorization = (currentPages=[], user, userRoles) => {
    if (!currentPages.length) return true;

    return currentPages.every(currentPageArray => {
        if (!currentPageArray.length || !currentPageArray[0].fieldPageProtectionByRole || !currentPageArray[0].fieldPageProtectionByRole.length) return true;
        const currentPage = currentPageArray[0];

        // Fetch required page roles
        const roles = currentPage.fieldPageProtectionByRole.map(role => role.targetId);
        if (!roles.length) return true;

        // Fetch User roles
        if (!user || !user.name) return false;

        // Auto allow administrators
        if (userRoles.includes('administrator')) return true;

        // Auto allow when page allowed for Authenticated users
        if (roles.includes('authenticated')) return true;

        return roles.some(role => userRoles.includes(role));
    });
};

class App extends Component {
    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        location: PropTypes.object.isRequired,
        cookies: PropTypes.instanceOf(Cookies).isRequired
    };

    state = {
        headerType: 'primary',
        footerType: 'primary',
        subNav: null,
        mediaPathId: 'loading',
        scriptsLoaded: false,
        contentLoaded: false,
        twillSlug: null,
        twillInfo: {},
        twillPreview: false,
        twillSlugFetched: false,
        twillRoutesFetched: false,
        twillRoutes: [],
        // Used to determine if all routes with additional filtering have finished loading
        twillRouteFilteringComplete: {
            whatsNew: false,
        },
    };


    async componentDidMount() {
        const currentPath = location && location.pathname ? location.pathname : '';

        if (this.isTwillPreviewLink()) {
            return;
        }
        
        // let's check if on Twill first
        request.get(`${twillBase}/api/alias/${currentPath}`).then(res => {
            this.setState({twillSlugFetched: true});


            if (!res || !res.body) {
                console.info("no twill alias response", res.title);
                return;
            }

            if (res.body.title) {
                document.title = `${res.body.title} | MarketAxess`;
            }

            if (res.body.slug && res.body.link_type) {

                if (res.body.link_type === 'file_alias') {
                    window.location.href = `https://www.marketaxess.com/twli/${res.body.slug}`;
                    return;
                }

                this.setState({twillInfo: res.body, twillSlug: `${res.body.slug}`});
                this.loadAdditionalScripts();
            }
        }).catch(err => {
                this.setState({twillSlugFetched: true});
                console.error(err);
                // Translate Path with Decoupled Router
                request.get(`${API.getHost()}/router/translate-path?path=${currentPath}`).then(drupalRes => {

                    // Set title via TranslatePath for GTM
                    if (drupalRes && drupalRes.body && drupalRes.body.label) {
                        document.title = `${drupalRes.body.label} | MarketAxess`;
                    }

                    if (drupalRes && drupalRes.body && drupalRes.body.entity && drupalRes.body.entity.id) {
                        this.setState({mediaPathId: drupalRes.body.entity.id});
                    } else {
                        this.setState({mediaPathId: null});
                    }
                    this.loadAdditionalScripts();
                }).catch(() => {
                    this.setState({mediaPathId: null});
                    this.loadAdditionalScripts();
                });

            });



        // Prevent API Caching for External Previews with ?v= parameter on the request
        const externalPreview = getParameterByName('external_preview');
        let twillBaseCachePath = '';
        if (externalPreview && externalPreview === '939478355493') {
            twillBaseCachePath = `?v=${Date.now()}`
        }

        // Fetch Twill API Routes and Data
        // TODO: Store in Redux to prevent refiring via KnowledgeCenterQuery.getKnowledgeCenterItems and WhatsNew.getWhatsNewItems etc.
        const twillRoutes = await fetch(`${twillBase}/api/all${twillBaseCachePath}`).then(res => res.json())

        // eslint-disable-next-line react/no-did-mount-set-state
        if (twillRoutes) this.setState({
            twillRoutesFetched: true,
            twillRoutes
        });
    };

    componentWillUpdate() {
        // Reset floatingDLs
        window.floatingDLs = [];
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.contentLoaded && this.state.contentLoaded) {
            setTimeout(() => {
                const contentLoadedEvent = new CustomEvent('cmsContentLoaded', {
                    detail: { message: 'cmsContentLoaded' }
                });
                window.dispatchEvent(contentLoadedEvent);

                // Link video module CTAs
                linkVideoModules();
            }, 1000);

        }
    }


    getMenuLinks = (data, menuName) => {
        if (!data[menuName] || !data[menuName].links || !data[menuName].links.length) return [];

        return data[menuName].links;
    };

    /**
     * Get What's New Pages based on weighting system
     */
    getWhatsNewPages = (pages) => {

        const setLoaded = () => {
            // Set the whatsNew route as filter-complete to allow page rendering.
            const twillRouteFilteringComplete = this.state.twillRouteFilteringComplete;
            twillRouteFilteringComplete.whatsNew = true;
            this.setState(twillRouteFilteringComplete);
        };

        const updatePermalinks = (page, index) => {
            // Set Highest weighted to the Primary URL
            if (index === 0) {
                page.permalink = '/whatsnew/app/index.html'; // eslint-disable-line no-param-reassign
            }

            // Set others to dynamic URL
            else {
                page.permalink = `/whatsnew/app/whatsnewpage-${index}.html`; // eslint-disable-line no-param-reassign
            }

            return page;
        }


        // Prevent secondary filtering
        if (this.state.twillRouteFilteringComplete.whatsNew) return pages;

        const clientType = getParameterByName('clientType');
        const region = getParameterByName('region');
        const externalPreview = getParameterByName('external_preview');

        // Allow External Preview to override the order
        if (externalPreview && externalPreview === '939478355493' && (!clientType && !region)) {
            setLoaded();
            return pages.sort((pageA, pageB) =>  pageA.visible_preview === pageB.visible_preview ? 0 : pageA.visible_preview ? -1 : 1).map((page, index) => updatePermalinks(page, index));
        }

        // Return unmodified if no query param is set
        if (!region || !clientType) {
            setLoaded();
            return pages;
        }

        let matchingPageExists = false;

        // Match Page based on client and dealer queryparameters against the `visible_` fields.
        const getMatchingPagesByDealerAndClient = (post) => {
            if (!post) return false;

            const isClient = (clientType.toLowerCase() === 'client' || clientType.toLowerCase() === 'c');
            const isDealer = (clientType.toLowerCase() === 'dealer' || clientType.toLowerCase() === 'd');

            return (post.visible_client_asia && isClient && region.toLowerCase() === 'asia') ||
                   (post.visible_client_latin && isClient && region.toLowerCase() === 'latam') ||
                   (post.visible_client_mena && isClient && (region.toLowerCase() === 'ceema' || region.toLowerCase() === 'mena')) ||
                   (post.visible_client_na && isClient && region.toLowerCase() === 'us') ||
                   (post.visible_client_uk && isClient && region.toLowerCase() === 'uk') ||
                   (post.visible_dealer_asia && isDealer && region.toLowerCase() === 'asia') ||
                   (post.visible_dealer_latin && isDealer && region.toLowerCase() === 'latam') ||
                   (post.visible_dealer_mena && isDealer && (region.toLowerCase() === 'ceema' || region.toLowerCase() === 'mena')) ||
                   (post.visible_dealer_na && isDealer && region.toLowerCase() === 'us') ||
                   (post.visible_dealer_uk && isDealer && region.toLowerCase() === 'uk');
        };

        const sortedPages = pages.sort((pageA, pageB) => {
            const pageAMatched = getMatchingPagesByDealerAndClient(pageA);
            const pageBMatched = getMatchingPagesByDealerAndClient(pageB);

            const match = pageAMatched === pageBMatched ? 0 : pageAMatched ? -1 : 1;

            if (match) matchingPageExists = true;

            return match;
        });

        setLoaded();

        // If no weighting is set return unmodified
        if (!matchingPageExists) return pages.map((page, index) => updatePermalinks(page, index));

        // If weighting exists, return the sorted pages.
        return sortedPages.map((page, index) => updatePermalinks(page, index));
    };

    isTwillPreviewLink = () => {
        const url = new URL(document.location.href);
        const pathname = url.pathname;
        const params = url.searchParams;

        const isPreviewPath = pathname.startsWith('/preview');
        const hasRequiredParams = params.has('expires') && params.has('revision') && params.has('signature');
        if (isPreviewPath) {
            this.setState({twillSlug: pathname, twillPreview: true, twillSlugFetched: true});
        }
        return isPreviewPath && hasRequiredParams;
    }

    loadAdditionalScripts = () => {
        if (this.state.scriptsLoaded) return;

        analyticsListeners(trackPage);


        // eslint-disable-next-line no-extra-boolean-cast
        if (window.location.pathname === '/sustainability/resources') {
            postscribe(`#app`, '<script async defer src="https://cdn.cyber-risk.upguard.com/widget.js"></script>');
        }


        document.addEventListener('input', event => {

            const state = document.getElementById('state');

            // Handle Contact Us page dropdown switching
            if (state && event.target.id === 'country' && event.target.value === 'United States') {
                const selectWrapper = document.createElement('div');
                selectWrapper.id = 'contact_form_state_us_dropdown_select';
                selectWrapper.classList.add('form__input--select__wrapper');
                selectWrapper.innerHTML = '<select id="contact_form_state_us_dropdown_select_input"><option value="">Select State</option><option value="AL">AL</option><option value="AK">AK</option><option value="AZ">AZ</option><option value="AR">AR</option><option value="CA">CA</option><option value="CO">CO</option><option value="CT">CT</option><option value="DE">DE</option><option value="FL">FL</option><option value="GA">GA</option><option value="HI">HI</option><option value="ID">ID</option><option value="IL">IL</option><option value="IN">IN</option><option value="IA">IA</option><option value="KS">KS</option><option value="KY">KY</option><option value="LA">LA</option><option value="ME">ME</option><option value="MD">MD</option><option value="MA">MA</option><option value="MI">MI</option><option value="MN">MN</option><option value="MS">MS</option><option value="MO">MO</option><option value="MT">MT</option><option value="NE">NE</option><option value="NV">NV</option><option value="NH">NH</option><option value="NJ">NJ</option><option value="NM">NM</option><option value="NY">NY</option><option value="NC">NC</option><option value="ND">ND</option><option value="OH">OH</option><option value="OK">OK</option><option value="OR">OR</option><option value="PA">PA</option><option value="RI">RI</option><option value="SC">SC</option><option value="SD">SD</option><option value="TN">TN</option><option value="TX">TX</option><option value="UT">UT</option><option value="VT">VT</option><option value="VA">VA</option><option value="WA">WA</option><option value="WV">WV</option><option value="WI">WI</option><option value="WY">WY</option></select>';

                state.after(selectWrapper);
                state.value = '';
                state.type = 'hidden';

            } else if (state && event.target.id === 'country') {
                const selectElement = document.getElementById('contact_form_state_us_dropdown_select');
                if (selectElement) {
                    selectElement.parentNode.removeChild(selectElement);
                }

                state.value = '';
                state.type = 'text';
            }

            // Store dropdown selection in State field for Contact page
            if (state && event.target.id === 'contact_form_state_us_dropdown_select_input') {
                state.value = event.target.value;
            }

        }, false);

        this.setState({scriptsLoaded: true});
    };

    checkTwillRender = (currentPath, isDealerRankings) => {
        const individualArticleContent = this.renderArticle(currentPath, isDealerRankings);

        if (individualArticleContent) {
            return individualArticleContent;
        }

        const twillContent = this.renderTwill(currentPath, isDealerRankings);

        if (twillContent) {
            return twillContent;
        }

        return null;
    }

    checkIfNavNeedsToBeHidden = (isDealerRankings) => {
        if (isDealerRankings) {
            return true;
        }

        if (this.state.twillInfo && this.state.twillInfo.hide_navigation === 1) {
            return true;
        }

        return false;
    }

    renderArticle = (currentPath, isDealerRankings) => {

        if (!this.state.twillSlug || !currentPath.startsWith('/article/')) {
            return null;
        }
            return (

                <div className="root">
                    <div className="app">
                        <div className={`node twill node-${slugifyUrl(currentPath)}`}>
                            <div className="print_logo"><img src="/public/images/global/logo_black.svg"
                                                             alt="MarketAxess"/></div>

                            <Header disableHeaderSocial={isDealerRankings}
                                    disableHeaderNav={isDealerRankings}
                                    disableHeaderLogo={isDealerRankings}
                                    links={[]}
                                    subNav={this.state.twillInfo.sub_nav_key}
                            />
                            {
                                this.state.twillRoutes
                                    .filter(twillKnowledgeCenterRoute => twillKnowledgeCenterRoute.post_type === 'article')
                                    .filter(twillKnowledgeCenterRoute => twillKnowledgeCenterRoute.permalink)
                                    .map(twillKnowledgeCenterRoute => (
                                        <Route
                                            key={`route_twill_${twillKnowledgeCenterRoute.permalink}`}
                                            exact
                                            path={twillKnowledgeCenterRoute.permalink}
                                            render={(props) =>
                                                <KnowledgeCenterQuery
                                                    id={twillKnowledgeCenterRoute.id}
                                                    markComponentLoadedAs={() => {
                                                    }}
                                                    article={twillKnowledgeCenterRoute} {...props} />}
                                        />
                                    ))
                            }
                            <CareersFooter info={this.state.twillInfo}/>
                            {isDealerRankings ? null : <Footer/>}
                        </div>
                    </div>
                </div>

            );
    }

    renderChartsIfApplicable = () => {
        if (!this.state.twillSlug.startsWith('/index/CPP-basi') && !this.state.twillSlug.startsWith('/cpp-basi-chart')) {
            return null;
        }
        return (<Route path="/index" component={IndexCharts}/>);

    }

    renderCareersStoriesIfApplicable = () => {
        if (this.state.twillSlug.startsWith('/careers/stories')) {
            return (<CareersQuery
                id={this.state.twillInfo.id}
                markComponentLoadedAs={() => {
                }}
                article={this.state.twillInfo} />);
        }
        return null;
    }

    renderTwill = (currentPath, isDealerRankings) => {
        if (!this.state.twillSlug) {
            return null;
        }

        const disableNavs = this.checkIfNavNeedsToBeHidden(isDealerRankings);

            return (
                <div className="root">
                    <div className="app">
                        <div className={`node twill node-${slugifyUrl(currentPath)}`}>
                            <div className="print_logo"><img src="/public/images/global/logo_black.svg"
                                                             alt="MarketAxess"/></div>

                            <Header disableHeaderSocial={disableNavs}
                                    disableHeaderNav={disableNavs}
                                    disableHeaderLogo={disableNavs}
                                    links={[]}
                                    subNav={this.state.twillInfo.sub_nav_key}
                            />

                            { this.renderChartsIfApplicable()
                                || this.renderCareersStoriesIfApplicable()
                                || <TwillContent path={this.state.twillInfo.slug} preview={this.state.twillPreview} />
                            }

                            <CareersFooter info={this.state.twillInfo}/>
                            {disableNavs ? null : <Footer/> }
                        </div>
                    </div>
                </div>
            );
    }




        render() {
        const {cookies, location} = this.props;
        const currentPath = location && location.pathname ? location.pathname : '';

        const isDealerRankings = window.location.pathname.includes("tradinghomepage/");


        const twillContentItem = this.checkTwillRender(currentPath, isDealerRankings);

        if (twillContentItem) {
            if (!this.state.contentLoaded) {
                this.setState({contentLoaded: true});
            }
            return twillContentItem;
        }



        if (!this.state.twillSlugFetched) {
            return <PulsatingLogo show />
        }


            const userQueryObject = {
                "data": {
                    "currentUserContext": {
                        "created": 1523034015,
                        "timezone": "",
                        "mail": null,
                        "name": "",
                        "uuid": "25cd399b-7246-4aa1-86e8-3fcf2e2331a7",
                        "uid": 0,
                        "roles": [],
                        "__typename": "User"
                    }
                }
            };

        let currentUserRoles = userQueryObject.data.currentUserContext.roles;
        if (currentUserRoles.length) {
            currentUserRoles = currentUserRoles.map((roleObject) => roleObject.targetId);
        }

        const currentUserContext = userQueryObject.data.currentUserContext;

        // Set Auth Context if available
        if (userQueryObject.data && userQueryObject.data.currentUserContext && userQueryObject.data.currentUserContext.uuid) {
            cookies.set('x-context', userQueryObject.data.currentUserContext.uuid, {path: '/'});
        }

        if (window.location.pathname.includes("whatsnew/app")) {

            // Halt until Twill Routes are loaded
            if (!this.state.twillRoutesFetched) return null;

            const currentWhatsNewPage = this.getWhatsNewPages(this.state.twillRoutes.filter(route => route.post_type === 'whatsnew')).filter(page =>
                page.permalink && stripTrailingSlash(page.permalink) === stripTrailingSlash("/whatsnew/app/index.html")
            );

           return (
                    <WhatsNew {...currentWhatsNewPage[0]} />
            );
        }

        if (window.location.pathname.startsWith("/live-markets")) {
            return (<LiveMarkets />);
        }

        if (window.location.pathname.startsWith("/timeline_milestone")) {
            return (<TimelineMilestoneQuery />);
        }


        const translatePathId = this.state.mediaPathId || null;
        if (translatePathId === 'loading') return null;

                        return (

                        <div className="root">
                            <div className="app d">




                                            <Query asyncMode query={GET_TRANSLATE_PATH_QUERY}
                                                   variables={{id: translatePathId}}>
                                                {(translatePathObject) => {

                                                    if (translatePathObject.loading) return null;
                                                    if (translatePathObject.error) return <div>{translatePathObject.error}</div>;

                                                    const pageByPath = translatePathObject.data ? translatePathObject.data.nodeById : null;



                                                    return (
                                                        <PagesQuery asyncMode query={GET_PAGES}>
                                                            {({loading, error, data}) => {

                                                                console.log('load state:')
                                                                console.log({
                                                                    twillRoutesFetched: this.state.twillRoutesFetched,
                                                                    twillRouteFilteringComplete: this.state.twillRouteFilteringComplete,
                                                                });

                                                                // Halt until Twill Routes are loaded
                                                                if (!this.state.twillRoutesFetched) return null;

                                                                console.log('Routes are loaded, continuing');

                                                                // Twill based Current Pages
                                                                const currentWhatsNewPage = this.getWhatsNewPages(this.state.twillRoutes.filter(route => route.post_type === 'whatsnew')).filter(page =>
                                                                    page.permalink && stripTrailingSlash(page.permalink) === stripTrailingSlash(location.pathname)
                                                                );

                                                                console.log("Current Whats new");
                                                                console.log(currentWhatsNewPage);

                                                                const twillRouteFilteringComplete = this.state.twillRouteFilteringComplete && Object.values(this.state.twillRouteFilteringComplete).length ? Object.values(this.state.twillRouteFilteringComplete).every(routeComplete => routeComplete) : true;

                                                                // Ensure both GraphQL and Twill API routes are loaded after Twill has loaded and filtered
                                                                if (!twillRouteFilteringComplete || loading) return null;
                                                                if (error) return <div>{error}</div>;

                                                                console.log('No longer loading, continue...');


                                                                let disableHeaderSocial = false;
                                                                let disableHeaderNav = false;
                                                                let disableHeaderLogo = false;
                                                                let disableFooter = false;

                                                                let currentLandingPage = data.landingPagesGraphqlMixed.results.filter(page => isLandingPage(page.entityBundle) &&
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === stripTrailingSlash(location.pathname)
                                                                );

                                                                // Load the Homepage by API.homePageId
                                                                if (!(currentLandingPage && currentLandingPage.length) && currentPath === '/') {
                                                                    currentLandingPage = data.landingPagesGraphqlMixed.results.filter(page => page.entityId === API.homePageId);
                                                                    if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].entityUrl) {
                                                                        currentLandingPage[0].entityUrl.path = '/';
                                                                    }
                                                                }
                                                                // Redirect Homepage path to /
                                                                if (currentLandingPage && currentLandingPage.length && currentLandingPage[0].entityId === API.homePageId && currentPath !== '/') {
                                                                    window.location = '/';
                                                                }

                                                                // Drupal/GQL Based Current Pages
                                                                let currentIntroPage = data.siteIntroGraphql.results.filter(page =>
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === stripTrailingSlash(location.pathname)
                                                                );
                                                                let currentArticlePage = data.articlesGraphql.results.filter(page =>
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === stripTrailingSlash(location.pathname)
                                                                );
                                                                let currentSftrLandingPage = data.sftrInfographicLandingGraphql.results.filter(page =>
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === stripTrailingSlash(location.pathname)
                                                                );
                                                                let currentMobileOptimizedPage = data.mobileOptimizedPageGraphqlView.results.filter(page =>
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === stripTrailingSlash(location.pathname)
                                                                );

                                                                // eslint-disable-next-line dot-notation
                                                                const pageByPathType = pageByPath && pageByPath['__typename'] ? pageByPath['__typename'] : null;

                                                                // Fall back to TranslatePath query if page is not yet cached
                                                                // eslint-disable-next-line dot-notation

                                                                if ((!currentLandingPage.length && !currentIntroPage.length && !currentWhatsNewPage.length && !currentSftrLandingPage.length && !currentMobileOptimizedPage.length && !currentArticlePage.length) && pageByPathType) {

                                                                    // Landing Pages
                                                                    if (pageByPathType === 'NodeLandingPage') {
                                                                        currentLandingPage = [pageByPath];
                                                                        data.landingPagesGraphqlMixed.results.push(pageByPath);
                                                                    } else if (pageByPathType === 'NodeLegalPage') {
                                                                        currentLandingPage = [pageByPath];
                                                                        data.landingPagesGraphqlMixed.results.push(pageByPath);
                                                                    } else if (pageByPathType === 'NodePostTradePage') {
                                                                        currentLandingPage = [pageByPath];
                                                                        data.landingPagesGraphqlMixed.results.push(pageByPath);
                                                                    } else if (pageByPathType === 'NodeDealerRankingsPage') {
                                                                        // Do not assign currentLandingPage for dealers as it will take priority
                                                                        // currentLandingPage = [pageByPath];
                                                                        // data.landingPagesGraphqlMixed.results.push(pageByPath);
                                                                    }

                                                                    // Intro Pages
                                                                    else if (pageByPathType === 'NodeSiteIntroPage') {
                                                                        currentIntroPage = [pageByPath];
                                                                        data.siteIntroGraphql.results.push(pageByPath);
                                                                    }

                                                                    // SFTR Landing Pages
                                                                    else if (pageByPathType === 'NodeSftrInfographicLanding') {
                                                                        currentSftrLandingPage = [pageByPath];
                                                                        data.sftrInfographicLandingGraphql.results.push(pageByPath);
                                                                    }

                                                                    // Article Pages
                                                                    else if (pageByPathType === 'NodeArticle') {
                                                                        currentArticlePage = [pageByPath];
                                                                        data.articlesGraphql.results.push(pageByPath);
                                                                    }

                                                                    // Mobile Optimized Pages
                                                                    else if (pageByPathType === 'NodeMobileOptimizedPage') {
                                                                        currentMobileOptimizedPage = [pageByPath];
                                                                        data.mobileOptimizedPageGraphqlView.results.push(pageByPath);
                                                                    }
                                                                }

                                                                const menuLogoOverride = {
                                                                    // logoAlt: null,
                                                                    // logo: null,
                                                                    // logoClass: null
                                                                };

                                                                // Set Header/Footer options for Actual Pages
                                                                if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].fieldContainerOptions && currentLandingPage[0].fieldContainerOptions.length) {
                                                                    disableHeaderSocial = currentLandingPage[0].fieldContainerOptions.includes('no_top_bar');
                                                                    disableHeaderNav = currentLandingPage[0].fieldContainerOptions.includes('no_navigation');
                                                                    disableHeaderLogo = currentLandingPage[0].fieldContainerOptions.includes('no_logo');
                                                                    disableFooter = currentLandingPage[0].fieldContainerOptions.includes('no_footer');
                                                                } else if (currentIntroPage.length || currentPath.startsWith('/tradinghomepage')) {
                                                                    disableHeaderSocial = true;
                                                                    disableHeaderNav = true;
                                                                    disableHeaderLogo = true;
                                                                    disableFooter = true;
                                                                } else if (currentWhatsNewPage.length) {
                                                                    disableHeaderSocial = true;
                                                                    disableHeaderNav = true;
                                                                    disableHeaderLogo = true;
                                                                    disableFooter = true;
                                                                } else if (currentSftrLandingPage.length) {
                                                                    disableHeaderSocial = false;
                                                                    disableHeaderNav = false;
                                                                    disableHeaderLogo = false;
                                                                    disableFooter = true;
                                                                } else if (currentMobileOptimizedPage.length) {
                                                                    disableHeaderSocial = true;
                                                                    disableHeaderNav = false;
                                                                    disableHeaderLogo = false;
                                                                    disableFooter = true;
                                                                    menuLogoOverride.logoAlt = 'You\'re in the Market';
                                                                    menuLogoOverride.logo = 'https://assets.marketaxess.com/2019-09/YoureInTheMarketHeaderLogo.png';
                                                                    menuLogoOverride.menuClass = 'yitmMobile';
                                                                } else if (currentArticlePage.length) {
                                                                    disableHeaderSocial = false;
                                                                    disableHeaderNav = false;
                                                                    disableHeaderLogo = false;
                                                                    disableFooter = false;
                                                                } else if (currentPath.startsWith('/timeline_milestone')) {
                                                                    disableHeaderSocial = true;
                                                                    disableHeaderNav = true;
                                                                    disableHeaderLogo = true;
                                                                    disableFooter = true;
                                                                }

                                                                let PageNotFoundEntity = data.landingPagesGraphqlMixed.results.filter(page =>
                                                                    isLandingPage(page.entityBundle) &&
                                                                    page.entityUrl && stripTrailingSlash(page.entityUrl.path) === '/auto/404'
                                                                );

                                                                if (Array.isArray(PageNotFoundEntity)) {
                                                                    PageNotFoundEntity = PageNotFoundEntity[0];
                                                                }

                                                                const userRoles = currentUserRoles;
                                                                const isAdmin = userRoles.includes('administrator');
                                                                const isSuperUser = userRoles.includes('super_user');
                                                                const isPostTradeEditor = userRoles.includes('post_trade_editor_role');
                                                                let allowedToAccessPage = checkAuthorization([currentLandingPage, currentIntroPage], currentUserContext, userRoles);

                                                                // Auth for Revision Pages
                                                                const revisionPage = currentPath.match(/\/node\/(\d+)\/revisions\/(\d+)\/view/) || currentPath.match(/\/node\/(\d+)\/latest/);
                                                                if (revisionPage && ((!isAdmin && !isSuperUser && !isPostTradeEditor) || !currentUserContext.name)) {
                                                                    allowedToAccessPage = false;
                                                                }

                                                                if (revisionPage && window.lin.lr && currentPath.match(/\/node\/(\d+)\/latest/)) {
                                                                    revisionPage[2] = window.lin.lr;
                                                                }

                                                                // Auth requirement for Drafts
                                                                if ((
                                                                    (currentLandingPage && currentLandingPage[0] && currentLandingPage[0].entityPublished !== undefined && !currentLandingPage[0].entityPublished) ||
                                                                    (currentIntroPage && currentIntroPage[0] && currentIntroPage[0].entityPublished !== undefined && !currentIntroPage[0].entityPublished) ||
                                                                    (currentArticlePage && currentArticlePage[0] && currentArticlePage[0].entityPublished !== undefined && !currentArticlePage[0].entityPublished) ||
                                                                    (currentWhatsNewPage && currentWhatsNewPage[0] && currentWhatsNewPage[0].published !== undefined && !currentWhatsNewPage[0].published) ||
                                                                    (currentSftrLandingPage && currentSftrLandingPage[0] && currentSftrLandingPage[0].entityPublished !== undefined && !currentSftrLandingPage[0].entityPublished) ||
                                                                    (currentMobileOptimizedPage && currentMobileOptimizedPage[0] && currentMobileOptimizedPage[0].entityPublished !== undefined && !currentMobileOptimizedPage[0].entityPublished)
                                                                ) && ((!isAdmin && !isSuperUser && !isPostTradeEditor) || !currentUserContext.name)) {
                                                                    allowedToAccessPage = false;
                                                                }

                                                                let slugifiedUrl = slugifyUrl(currentPath);
                                                                if (slugifiedUrl === '/' || slugifiedUrl === '') slugifiedUrl = 'home';

                                                                // Pass down specific props to a revision where RevisionQuery will not fetch them.
                                                                let revisionProps = {};

                                                                // Determine Nav Type by Landing Page
                                                                if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].overridePrimaryNavigationMenu && currentLandingPage[0].overridePrimaryNavigationMenu.entity && currentLandingPage[0].overridePrimaryNavigationMenu.entity.entityId) {
                                                                    if (currentLandingPage[0].overridePrimaryNavigationMenu.entity.entityId === 'liquidity-edge-navigation') {
                                                                        if (this.state.headerType !== 'liquidity_edge') {
                                                                            this.setState({headerType: 'liquidity_edge'});
                                                                        }
                                                                    } else if (this.state.headerType === 'liquidity_edge') {
                                                                        this.setState({headerType: 'primary'});
                                                                    }
                                                                } else if (!revisionPage && this.state.headerType === 'liquidity_edge') {
                                                                    this.setState({headerType: 'primary'});
                                                                }

                                                                // Determine if a SubNav is used
                                                                if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].fieldSubNavigationMenu && currentLandingPage[0].fieldSubNavigationMenu.entity && currentLandingPage[0].fieldSubNavigationMenu.entity.entityId) {
                                                                    if (this.state.subNav !== currentLandingPage[0].fieldSubNavigationMenu.entity.entityId) {
                                                                        this.setState({subNav: currentLandingPage[0].fieldSubNavigationMenu.entity.entityId});
                                                                    }
                                                                }

                                                                // Determine if Footer Override exists
                                                                if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].fieldOverrideFooter && currentLandingPage[0].fieldOverrideFooter.entity && currentLandingPage[0].fieldOverrideFooter.entity.entityId) {
                                                                    if (this.state.footerType !== currentLandingPage[0].fieldOverrideFooter.entity.entityId) {
                                                                        this.setState({footerType: currentLandingPage[0].fieldOverrideFooter.entity.entityId});
                                                                    }
                                                                }

                                                                // Set Subnav for Careers Details page
                                                                if (
                                                                    currentPath.startsWith('/careers/current-openings/detail') ||
                                                                    currentPath.startsWith('/careers/stories/')
                                                                ) {
                                                                    if (this.state.subNav !== 'careers-secondary-nav') {
                                                                        this.setState({subNav: 'careers-secondary-nav'});
                                                                    }
                                                                }

                                                                // Determine if a SubNav is used (Legal Page)
                                                                if (currentLandingPage.length && currentLandingPage[0] && currentLandingPage[0].fieldSecondaryNavigationMenu && currentLandingPage[0].fieldSecondaryNavigationMenu.entity && currentLandingPage[0].fieldSecondaryNavigationMenu.entity.entityId) {
                                                                    if (this.state.subNav !== currentLandingPage[0].fieldSecondaryNavigationMenu.entity.entityId) {
                                                                        this.setState({subNav: currentLandingPage[0].fieldSecondaryNavigationMenu.entity.entityId});
                                                                    }
                                                                }

                                                                // Determine Header Type for Landing Pages Revision
                                                                if (data.landingPagesGraphqlMixed && revisionPage && revisionPage[1] && revisionPage[2] && data.landingPagesGraphqlMixed.results.filter(page => page.entityId === revisionPage[1])) {
                                                                    const landingPageRevision = data.landingPagesGraphqlMixed.results.filter(page => page.entityId === revisionPage[1]);
                                                                    revisionProps = landingPageRevision[0];

                                                                    const revisionHeaderTypeCookieSlug = `noderevisionbyidnav_${revisionPage[1]}_${revisionPage[2]}`;
                                                                    const revisionHeaderType = cookies.get(revisionHeaderTypeCookieSlug);

                                                                    // Fetch overridePrimaryNavigationMenu by Revision ID


//                                                        const authTokenRefreshable = (window.lin && window.lin.at) ? window.lin.at : '';

                                                                    if (!revisionHeaderType) {
                                                                        fetch(`${API.getHost()}/graphql`, {
                                                                            method: 'POST',
                                                                            headers: {
//                                                                    'Authorization': authTokenRefreshable ? `Basic ${authTokenRefreshable}` : '',
                                                                                'content-type': 'application/json'
                                                                            },
                                                                            body: JSON.stringify([{
                                                                                operationName: 'nodeRevisionByIdNav',
                                                                                query: 'query nodeRevisionByIdNav($id: String!) { nodeRevisionById(id: $id) { ... on NodeLandingPage { overridePrimaryNavigationMenu { entity { entityId } } } } }',
                                                                                variables: {id: revisionPage[2]}
                                                                            }])
                                                                        }).then(res => res.json()).then(res => {
                                                                            if (res.data && res.data.nodeRevisionById && res.data.nodeRevisionById.overridePrimaryNavigationMenu && res.data.nodeRevisionById.overridePrimaryNavigationMenu.entity && res.data.nodeRevisionById.overridePrimaryNavigationMenu.entity.entityId) {
                                                                                const headerType = res.data.nodeRevisionById.overridePrimaryNavigationMenu.entity.entityId;
                                                                                cookies.set(revisionHeaderTypeCookieSlug, headerType);
                                                                                if (headerType === 'liquidity-edge-navigation') {
                                                                                    this.setState({headerType: 'liquidity_edge'});
                                                                                }
                                                                            } else {
                                                                                cookies.set(revisionHeaderTypeCookieSlug, 'primary');
                                                                            }
                                                                        });
                                                                    }

                                                                    if (revisionHeaderType === 'liquidity-edge-navigation' && this.state.headerType !== 'liquidity_edge') {
                                                                        this.setState({headerType: 'liquidity_edge'});
                                                                    } else if (revisionHeaderType !== 'liquidity-edge-navigation' && this.state.headerType === 'liquidity_edge') {
                                                                        this.setState({headerType: 'primary'});
                                                                    }
                                                                }

                                                                return (
                                                                    <div className={`node node-${slugifiedUrl}`}>
                                                                        <div className="print_logo"><img
                                                                            src="/public/images/global/logo_black.svg"
                                                                            alt="MarketAxess"/></div>


                                                                        {this.state.headerType === 'primary' && data.mainMenu && data.mainMenu.links && (
                                                                            <Header
                                                                                disableHeaderSocial={disableHeaderSocial}
                                                                                disableHeaderNav={disableHeaderNav}
                                                                                disableHeaderLogo={disableHeaderLogo}
                                                                                links={data.mainMenu.links}
                                                                                subNav={this.state.subNav}
                                                                                {...menuLogoOverride}
                                                                            />
                                                                        )}

                                                                        {this.state.headerType === 'liquidity_edge' && data.liquidityEdgeMenu && data.liquidityEdgeMenu.links && (
                                                                            <LiquidityEdgeHeader
                                                                                links={data.liquidityEdgeMenu.links}/>
                                                                        )}

                                                                        <div style={{position: 'relative'}}>

                                                                            {allowedToAccessPage ? (
                                                                                <Switch>
                                                                                    <Route exact path="/auth/login"
                                                                                           component={AuthPage}/>
                                                                                    <Route path="/index"
                                                                                           component={IndexCharts}/>
                                                                                    <Route path="/inform/research"
                                                                                           component={Charts}/>
                                                                                    {/* <Route path="/solutions-hub/open-trading/:protocol" component={OpenTradingInteractive}/>
                                                                        <Route path="/solutions-hub/open-trading" component={OpenTradingInteractive}/> */}
                                                                                    <Route
                                                                                        path="/careers/current-openings/detail/:id"
                                                                                        component={JobSingle}/>

                                                                                    {revisionPage && revisionPage[2] && (
                                                                                        <Route path={currentPath}
                                                                                               render={(props) =>
                                                                                                   <Revision {...props} {...revisionProps}
                                                                                                             id={revisionPage[2]}
                                                                                                             nodeId={revisionPage[1]}/>
                                                                                               }/>
                                                                                    )}

                                                                                    {this.state.twillRoutes
                                                                                        .filter(twillKnowledgeCenterRoute => twillKnowledgeCenterRoute.post_type === 'article')
                                                                                        .filter(twillKnowledgeCenterRoute => twillKnowledgeCenterRoute.permalink)
                                                                                        .map(twillKnowledgeCenterRoute => (
                                                                                            <Route
                                                                                                key={`route_twill_${twillKnowledgeCenterRoute.permalink}`}
                                                                                                exact
                                                                                                path={twillKnowledgeCenterRoute.permalink}
                                                                                                render={(props) =>
                                                                                                    <KnowledgeCenterQuery
                                                                                                        id={twillKnowledgeCenterRoute.id}
                                                                                                        markComponentLoadedAs={() => {
                                                                                                        }}
                                                                                                        article={twillKnowledgeCenterRoute} {...props} />}
                                                                                            />
                                                                                        ))}

                                                                                    {data.sftrInfographicLandingGraphql && data.sftrInfographicLandingGraphql.results.filter(page => page.entityUrl).map(page => (
                                                                                        <Route
                                                                                            key={`route_sftr_lp_${page.entityUrl.path}`}
                                                                                            exact
                                                                                            path={page.entityUrl.path}
                                                                                            render={(props) =>
                                                                                                <InfographicLanding {...props} {...page} />}
                                                                                        />
                                                                                    ))}
                                                                                    {data.mobileOptimizedPageGraphqlView && data.mobileOptimizedPageGraphqlView.results.filter(page => page.entityUrl).map(page => (
                                                                                        <Route
                                                                                            key={`route_mobileoptpg_lp_${page.entityUrl.path}`}
                                                                                            exact
                                                                                            path={page.entityUrl.path}
                                                                                            render={(props) =>
                                                                                                <ComponentPage {...props}
                                                                                                               pageNotFoundEntity={PageNotFoundEntity}
                                                                                                               statusCode={page.entityUrl.path === '/auto/404' ? '404' : ''}
                                                                                                               id={page.entityId}/>}
                                                                                        />
                                                                                    ))}

                                                                                    {currentWhatsNewPage && currentWhatsNewPage[0] && currentWhatsNewPage[0].id ? (
                                                                                        <Route
                                                                                            key={`route_twill_wn_${currentWhatsNewPage[0].permalink}`}
                                                                                            exact
                                                                                            path={currentWhatsNewPage[0].permalink}
                                                                                            render={(props) =>
                                                                                                <WhatsNew {...props} {...currentWhatsNewPage[0]} />}
                                                                                        />
                                                                                    ) : null}

                                                                                    {data.siteIntroGraphql && data.siteIntroGraphql.results.filter(page => page.entityUrl).map(page => (
                                                                                        <Route
                                                                                            key={`route_si_${page.entityUrl.path}`}
                                                                                            exact
                                                                                            path={page.entityUrl.path}
                                                                                            render={(props) =>
                                                                                                <SiteIntroPage {...props} {...page} />}
                                                                                        />
                                                                                    ))}

                                                                                    {data.landingPagesGraphqlMixed && data.landingPagesGraphqlMixed.results.filter(page => page.entityUrl).map(page => (
                                                                                        <Route
                                                                                            key={`route_lp_${page.entityUrl.path}`}
                                                                                            exact
                                                                                            path={page.entityUrl.path}
                                                                                            render={(props) =>
                                                                                                <ComponentPage {...props}
                                                                                                               pageNotFoundEntity={PageNotFoundEntity}
                                                                                                               statusCode={page.entityUrl.path === '/auto/404' ? '404' : ''}
                                                                                                               id={page.entityId}/>}
                                                                                        />
                                                                                    ))}
                                                                                    { (this.state.twillSlug && this.state.twillSlug.startsWith('/careers/stories/')) ? (
                                                                                        <Route
                                                                                            key={`route_article_${this.state.twillSlug}`}
                                                                                            exact
                                                                                            path={this.state.twillSlug}
                                                                                            render={(props) =>
                                                                                                <CareersQuery
                                                                                                    id={this.state.twillInfo.id}
                                                                                                    markComponentLoadedAs={() => {
                                                                                                    }}
                                                                                                    article={this.state.twillInfo} {...props} />}
                                                                                        />
                                                                                    ) : null}

                                                                                    {data.ukDealers && data.ukDealers.links && data.ukDealers.links.length ? (
                                                                                        <Route
                                                                                            path="/tradinghomepage/uk"
                                                                                            render={props =>
                                                                                                <DealerRankings
                                                                                                    dealers={data.ukDealers.links} {...props}/>}/>
                                                                                    ) : null}

                                                                                    {data.usDealers && data.usDealers.links && data.usDealers.links.length ? (
                                                                                        <Route path="/tradinghomepage"
                                                                                               render={props =>
                                                                                                   <DealerRankings
                                                                                                       dealers={data.usDealers.links} {...props}/>}/>
                                                                                    ) : null}

                                                                                    {this.state.mediaPathId && (
                                                                                        <Route render={props => <Media
                                                                                            id={this.state.mediaPathId} {...props}/>}/>
                                                                                    )}

                                                                                    {/* 404 Landing Page with Fallback to Basic 404 */}
                                                                                    {PageNotFoundEntity && PageNotFoundEntity.entityId && (
                                                                                        <Route render={props =>
                                                                                            <ComponentPage {...props}
                                                                                                           pageNotFoundEntity={PageNotFoundEntity}
                                                                                                           statusCode="404"
                                                                                                           id={PageNotFoundEntity.entityId}/>}/>
                                                                                    )}

                                                                                    <Route component={PageNotFound}/>

                                                                                </Switch>
                                                                            ) : (!currentUserContext.name ? (
                                                                                <div className="container"><h1 style={{
                                                                                    padding: "20px",
                                                                                    color: "#EEEEEE"
                                                                                }}>Unable To Authorize</h1></div>
                                                                            ) : <div className="container"><h1>Not
                                                                                Authorized</h1></div>)}

                                                                            {!disableFooter && this.state.headerType === 'liquidity_edge' && (
                                                                                <LiquidityEdgeFooter/>
                                                                            )}


                                                                            {!disableFooter && this.state.footerType === 'footer-careers' ? (
                                                                                <CareersFooter/>
                                                                            ) : null}

                                                                        </div>
                                                                    </div>
                                                                )
                                                            }}
                                                        </PagesQuery>
                                                    );
                                                }}
                                            </Query>
                                <Footer/>

                            </div>
                        </div>
                        );
                        }
                        }

                        export default withRouter(withCookies(App));



// WEBPACK FOOTER //
// ./frontend/App.jsx